import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import newUserAppUrl from '../routing/newUserApp';
import urls from '../routing/urls';
import { selectCurrentUser } from '../selectors/authSelectors';

import {
  getFacebookShareLink,
  getLinkedInShareLink,
  getTwitterShareLink,
  getWhatsAppShareLink,
} from './commonHelper.js';

/**
 * Build a job share URL with optional referral-provider slug (`rp`), matching
 * My Referral Link attribution so Apply counts as a social referral.
 */
export const buildJobShareUrl = (jobUuid, referralProviderSlug) => {
  const base = `${newUserAppUrl}${urls.jobDetail.replace(':jobId', jobUuid)}`;
  if (!referralProviderSlug) return base;
  const separator = base.includes('?') ? '&' : '?';
  return `${base}${separator}rp=${encodeURIComponent(referralProviderSlug)}`;
};

export const useSocialShare = (id, opening, type) => {
  const { t } = useTranslation('common');
  const currentUser = useSelector(selectCurrentUser);

  return useCallback(
    (platform) => {
      let typeUrl;
      if (type === 'job') {
        typeUrl = buildJobShareUrl(id, currentUser?.slug);
      } else if (type === 'company') {
        typeUrl = newUserAppUrl + urls.companyProfile.replace(':companyName', id);
      }
      if (!typeUrl) return;

      let url;
      let text;
      switch (platform) {
        case 'LinkedIn':
          url = getLinkedInShareLink(typeUrl);
          break;
        case 'Twitter':
          if (type === 'job') {
            text = t('socialShare.checkoutJobOpening', {
              title: opening.title,
              company: opening.organization_name,
            });
          } else {
            text = t('socialShare.checkoutCompanyOpening', { company: opening.name });
          }
          url = getTwitterShareLink(typeUrl, text);
          break;
        case 'Facebook':
          url = getFacebookShareLink(typeUrl);
          break;
        case 'WhatsApp':
          url = getWhatsAppShareLink(typeUrl);
          break;
        default:
          throw new Error('Invalid social media type');
      }

      setTimeout(() => {
        window.open(url, '_blank');
      }, 100);
    },
    [id, opening?.name, opening?.title, opening?.organization_name, type, t, currentUser?.slug]
  );
};
